import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { findAncestor, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';

const RequestedDates = observer(class RequestedDates extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.cancelRequest = this.cancelRequest.bind(this);
  }

  initSchedule(e, proctorLocationSid, sessionSid, examSid) {
    if(getURLSegment(this, 1) === 'schedule-session') {
      this.props.routing.push(`/messages/view/${this.props.messageSid}`);

      setTimeout(function(){
        const scheduleBtn = document.querySelector('.requested-dates .btn--success');

        if(scheduleBtn) {
          scheduleBtn.click();
        }
      }, 1000);
    }

    this.props.parent.setState({
      proctorLocationSid,
      sessionSid,
      examSid
    });

    if(this.props.external) {
      this.props.parent.setState({
        confirmedDate: this.props.confirmedDate,
        messageSid: this.props.messageSid
      });
    }

    if(!this.props.drawer) {
      this.props.toggleDrawer(e, this.props.parent, 'ScheduleMessaging');
    } else {
      this.props.parent.setState({
        drawerContent: 'ScheduleMessaging'
      });
    }
  }

  cancelRequest(e) {
    const datesEl = findAncestor(e.target, 'requested-dates')

    this.props.store.MessageStore.cancelRequest(this.props.messageSid, datesEl);
  }

  render() {
    const { translation } = this.props;
    const { threadObject } = this.props.store.MessageStore;
    const { userTimezone } = this.props.store.SessionStore;
    const _this = this;

    let confirmedDate = null;
    let confirmedDateExpiration = null;
    let proctor = null;
    let proctorAccountLocationSid = null;
    let sessionSid = null;
    let examSid = null;

    if(this.props.external) {
      // If we’re not in the context of a
      // message thread (e.g. student exam cards)
      // we get the  data passed via props
      confirmedDate = this.props.confirmedDate;
      confirmedDateExpiration = this.props.confirmedDateExpiration;
      proctor = this.props.proctor;
      proctorAccountLocationSid = this.props.proctorAccountLocationSid;
      sessionSid = this.props.thisSessionSid;
      examSid = this.props.thisExamSid;
    } else {
      // Otherwise if we’re in a message thread
      // the data comes from the message store
      confirmedDate = threadObject.confirmedDate;
      confirmedDateExpiration = threadObject.confirmedDateExpiration;
      proctorAccountLocationSid = threadObject.proctorAccountLocationSid;
      sessionSid = threadObject.examSession.sid;
      examSid = threadObject.examSid;
    }

    const now = moment(this.props.store.SessionStore.currentTime);

    let expired = false;
    const expirationDate = moment(confirmedDateExpiration);
    const scheduleDiff = moment.duration(expirationDate.diff(now)).asHours();

    if(scheduleDiff < 0) {
      expired = true;
    }

    let past = false;
    const appointmentDate = moment(confirmedDate);
    const appointmentDiff = moment.duration(appointmentDate.diff(now)).asHours();

    let expDateAfterApptDate = false;
    const expApptDiff = moment.duration(appointmentDate.diff(expirationDate)).asHours();

    if(expApptDiff < 0) {
      expDateAfterApptDate = true;
    }

    if(appointmentDiff < 0) {
      past = true;
    }

    let dates = [];

    if(threadObject.dateOption1) {
      dates.push(threadObject.dateOption1);
    }

    if(threadObject.dateOption2) {
      dates.push(threadObject.dateOption2);
    }

    if(threadObject.dateOption3) {
      dates.push(threadObject.dateOption3);
    }

    // Proctor has confirmed a date
    // but student didn’t schedule
    // in time and now the confirmed
    // date is in the past
    if(past) {
      return (
        <div className={`requested-dates cta ${this.props.external ? 'cta--secondary' : ''}`}>
          <strong className="cta__copy">
            {translation.missed}
          </strong>

          <span className="cta__subcopy">
            {translation.missed_body.replace(
              '%date%',
              moment(appointmentDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma')
            )}
          </span>

          <button
            className="cta__btn btn--outline btn--negative"
            onClick={this.cancelRequest}
          >
            <icons.iconTimesCircle />
            {translation.cancel_button}
          </button>
        </div>
      )
    }

    if(!confirmedDate && !this.props.external) {
      // Show the requested dates if none have been confirmed yet
      return (
        <div className="thread__dates requested-dates">
          <strong>{translation.requested_dates}</strong>

          <ul className="date-opts">
            {dates.map(
              (date, i) =>
              <li key={i}>
                <span className="pill pill--lg">
                  {moment.utc(date).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                </span>
              </li>
            )}
          </ul>

          <button
            className="btn--outline btn--negative"
            onClick={(e) => {this.cancelRequest(e)}}
          >
            <icons.iconTimesCircle />
            {translation.cancel_button}
          </button>
        </div>
      )
    } else if(confirmedDate && !expired && !past) {
      // Show the schedule button if there’s a confirmed date and it hasn’t expired
      return (
        <div className={`requested-dates cta ${this.props.external ? 'cta--secondary' : ''}`}>
          {/* Show the proctor information if this is out of the message thread context */}
          {this.props.external &&
            <strong className="cta__copy">{proctor}</strong>
          }

          {this.props.external &&
            <strong className="cta__subcopy" aria-describedby="scheduleby-tooltip">
              {translation.confirmed_date} {moment.utc(confirmedDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
            </strong>
          }

          {/* Otherwise, just show the confirmed date */}
          {!this.props.external &&
            <strong className="cta__copy" aria-describedby="scheduleby-tooltip">
              {translation.confirmed_date} {moment.utc(confirmedDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
            </strong>
          }

          {!expDateAfterApptDate &&
            <span className="cta__subcopy">
              {translation.scheduleby.replace('%date%', moment.utc(confirmedDateExpiration).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}
            </span>
          }

          {expDateAfterApptDate &&
            <span className="cta__subcopy">
              {translation.schedulebefore}
            </span>
          }

          <button
            className="cta__btn btn--success"
            onClick={(e) => {this.initSchedule(e, proctorAccountLocationSid, sessionSid, examSid)}}
          >
            {translation.schedule_button}
          </button>

          <button
            className="cta__btn btn--outline btn--negative"
            onClick={this.cancelRequest}
          >
            <icons.iconTimesCircle />
            {translation.cancel_button}
          </button>
        </div>
      )
    } else if(confirmedDate && expired) {
      // If the confirmed date has expired, show a message
      return (
        <div className={`requested-dates cta ${this.props.external ? 'cta--secondary' : ''}`}>
          <strong className="cta__copy" aria-describedby="scheduleby-tooltip">
            {translation.expired_heading}
          </strong>
        </div>
      )
    }

    return null;
  }
})

export default translate('RequestedDates')(RequestedDates);



// WEBPACK FOOTER //
// ./src/app/components/Messages/RequestedDates.js